import React from 'react';
import { Form, InputGroup, Col } from 'react-bootstrap';
import { FastField, getIn } from 'formik';
import PropTypes from 'prop-types';
import { formLabel } from '~/utils/helpers';
import { Tooltip } from '~/components/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const FormNumber = ({
    sm,
    name,
    inputGroupPrepend,
    inputGroupAppend,
    isNegativeAllowed,
    className,
    min,
    max,
    tooltip,
    label,
}) => {
    const labelForm = label || formLabel(name);

    return (
        <FastField name={name}>
            {({ field, form, meta }) => {
                const isValid = !meta.error;
                const isInvalid = getIn(form.touched, name) && !isValid; //using getIn() instead of meta.touched b/c meta.touched with nested fields always  return false when clicking submit without touching the field first (which is contrary to what state in the doc: https://formik.org/docs/guides/form-submission#pre-submit)
                field.value = field.value ?? ''; //set field value to empty string ("") to avoid `Warning: `value` prop on `input` should not be null`.

                return (
                    <Form.Group
                        as={Col}
                        sm={sm}
                        className={className}
                    >
                        <Form.Label className="d-flex">
                            {tooltip ? (
                                <>
                                    {labelForm}
                                    <Tooltip content={tooltip}>
                                        <FontAwesomeIcon
                                            icon={faCircleInfo}
                                            size="xs"
                                            className="fa-light fa-fw ml-1"
                                        />
                                    </Tooltip>
                                </>
                            ) : (
                                labelForm
                            )}
                        </Form.Label>
                        <InputGroup>
                            {inputGroupPrepend}
                            <Form.Control
                                {...field}
                                type={'number'}
                                isValid={form.touched[field.name] && isValid}
                                isInvalid={isInvalid}
                                onKeyPress={(e) => {
                                    //allow number keypress only
                                    if (isNegativeAllowed) {
                                        return !/[-|0-9]/.test(e.key) && e.preventDefault();
                                    } else {
                                        return !/[0-9]/.test(e.key) && e.preventDefault();
                                    }
                                }}
                                onBlur={(e) => {
                                    const val = e.target.value;
                                    form.setFieldValue(field.name, isNaN(val) || val === '' ? '' : parseInt(val));
                                    form.handleBlur(e); //(1)
                                }}
                                min={min}
                                max={max}
                            />
                            {inputGroupAppend}
                            <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group>
                );
            }}
        </FastField>
    );
};

FormNumber.defaultProps = {
    className: '',
    inputGroupPrepend: null,
    inputGroupAppend: null,
    isNegativeAllowed: false,
    sm: 2,
    min: '',
    max: '',
    tooltip: '',
    label: '',
};

FormNumber.propTypes = {
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    inputGroupPrepend: PropTypes.node,
    inputGroupAppend: PropTypes.node,
    isNegativeAllowed: PropTypes.bool,
    tooltip: PropTypes.string,
    label: PropTypes.string,
};
export default FormNumber;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
